// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__zO4Ro","paramInput":"JobSimulator_paramInput__385A-","input":"JobSimulator_input__3Uq1C"};